//please do not change these as they are tied to naming convention of profile snapshot fields (onEdit, onCreate, etc.)
export enum ProfileSnapshotTypes {
  onEdit = 0,
  onCreate = 1,
  onConsent = 2,
  onSubmit = 3,
}
